// extracted by mini-css-extract-plugin
export default {"container":"TitleAndMenuList_container__HZKoE","horizontalList":"TitleAndMenuList_horizontalList__h+wzY"};